import { registerSheet, type SheetDefinition } from 'react-native-actions-sheet'

import { AddPaymentMethodSheet } from './AddPaymentMethodSheet'
import { OpenFilterSheet } from './OpenFilterSheet'
import { SelectImageSheet } from './SelectImageSheet'
import { SelectVideoSheet } from './SelectVideoSheet'
import { SellerComplaintSheet } from './SellerComplaintSheet'
import { WalletEventFilterSheet } from './WalletEventFilterSheet'

registerSheet('open-filter', OpenFilterSheet)
registerSheet('select-image', SelectImageSheet)
registerSheet('select-video', SelectVideoSheet)
registerSheet('wallet-event-filter', WalletEventFilterSheet)
registerSheet('add-payment-method', AddPaymentMethodSheet)
registerSheet('seller-complaint', SellerComplaintSheet)

declare module 'react-native-actions-sheet' {
  interface Sheets {
    'open-filter': SheetDefinition<{
      payload: { type: string; value: string; setValue: (value: string) => void; closeDrawer?: () => void }
    }>
    'select-image': SheetDefinition<{
      payload: { openCamera: () => void; openImageViewer: () => void }
    }>
    'select-video': SheetDefinition<{
      payload: { openImageViewer: () => void }
    }>
    'wallet-event-filter': SheetDefinition<{
      payload: { value: string; setValue: (value: string) => void; closeDrawer?: () => void }
    }>
    'add-payment-method': SheetDefinition<{
      payload: { onClose?: () => void; onCancel?: () => void }
    }>
    'seller-complaint': SheetDefinition<{
      payload: { openReviseOrderScreen: () => void; openAppealScreen: () => void }
    }>
  }
}
